import {isNil} from 'ramda';

import {parseDate} from 'shared/web';

export type PhotoCheckerReportStatus = 'processing' | 'completed' | 'failed' | null | undefined;

export function getPhotoCheckerReportCreatedAt(
  reportCreatedAt: string | null | undefined,
  reportStatus: PhotoCheckerReportStatus
): string | null | undefined {
  if (reportStatus === 'completed' || reportStatus === 'processing' || reportStatus === 'failed') {
    return reportCreatedAt;
  }

  return undefined;
}

export function getAlbumPhotosReferenceAt(
  photosUpdatedAt: string | null | undefined,
  albumCreatedAt: string | null | undefined
): string | null | undefined {
  return photosUpdatedAt ?? albumCreatedAt;
}

export function arePhotosNewerThanReportSnapshot(
  photosUpdatedAt: string | null | undefined,
  albumCreatedAt: string | null | undefined,
  reportCreatedAt: string | null | undefined
): boolean {
  const photosReferenceAt = getAlbumPhotosReferenceAt(photosUpdatedAt, albumCreatedAt);

  if (isNil(photosReferenceAt) || isNil(reportCreatedAt)) {
    return false;
  }

  const photosReferenceTime = parseDate(photosReferenceAt)?.getTime();
  const reportCreatedTime = parseDate(reportCreatedAt)?.getTime();

  if (isNil(photosReferenceTime) || isNil(reportCreatedTime)) {
    return false;
  }

  return photosReferenceTime > reportCreatedTime;
}

export function isPhotoCheckerResultStale(
  photosUpdatedAt: string | null | undefined,
  albumCreatedAt: string | null | undefined,
  reportCreatedAt: string | null | undefined,
  reportStatus?: PhotoCheckerReportStatus
): boolean {
  if (reportStatus !== 'completed') {
    return false;
  }

  return arePhotosNewerThanReportSnapshot(photosUpdatedAt, albumCreatedAt, reportCreatedAt);
}
